<h2 mat-dialog-title>{{data.title | translate: data.locale | async}} {{'Help' | translate: data.locale | async}}<i class="fa fa-close pull-right" style="cursor: pointer;" (click)="closeModal()"></i></h2>
<mat-dialog-content>
  <div [innerHTML]="content$ | async"></div>
</mat-dialog-content>
